import l from "react";
import d from "@appchoose/cn";
import y from "@appchoose/icon";
const w = ({
  appearance: o = "default",
  size: r = "default",
  title: n,
  icon: s,
  children: f,
  className: g,
  sideContent: m,
  ...u
}) => {
  const a = (e, t) => d("flex flex-col md:flex-row justify-between border space-x-6", {
    "bg-gray-50 border-gray-200": !e || e === "default",
    "bg-green-300 border-green-350": e === "success",
    "bg-beige-300 border-beige-400": e === "warning",
    "bg-red-300 border-red-350": e === "error",
    "p-8 rounded-lg": !t || t === "default",
    "p-6 rounded": t === "small"
  }), b = (e, t) => d("rounded-full", {
    "bg-red-350": (!t || t === "default") && e === "error",
    "bg-orange-350": (!t || t === "default") && e === "warning",
    "bg-green-350": (!t || t === "default") && e === "success",
    "bg-gray-300": (!t || t === "default") && (!e || e === "default"),
    "text-gray-700": !e || e === "default",
    "text-green-900": e === "success",
    "text-orange-600": e === "warning",
    "text-red-600": e === "error",
    "p-3": !t || t === "default"
  }), c = (e) => d("text-gray-700", {
    "text-sm font-semibold": e === "small",
    "text-base font-bold": !e || e === "default"
  }), x = (e) => d("w-full", {
    "space-y-1": e === "small"
  });
  return /* @__PURE__ */ l.createElement(
    "div",
    {
      className: [a(o, r), g].join(" "),
      ...u
    },
    /* @__PURE__ */ l.createElement("div", { className: "flex w-full items-start space-x-4 pb-4 md:pb-0" }, s ? /* @__PURE__ */ l.createElement("div", { className: b(o, r) }, /* @__PURE__ */ l.createElement(y, { icon: s, size: "large" })) : null, /* @__PURE__ */ l.createElement("div", { className: x(r) }, /* @__PURE__ */ l.createElement("div", { className: c(r) }, n), f)),
    m ? /* @__PURE__ */ l.createElement("div", { className: "shrink-0" }, m) : null
  );
};
w.displayName = "Alert";
export {
  w as default
};
